/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function() {
  // Add custom code below this line

  // =============================================
  // AUTO-PLAY FIRST PRODUCT VIDEO
  // Makes the first product gallery video autoplay
  // (muted, looping, inline) without requiring click
  // =============================================

  function initAutoplayProductVideo() {
    // Only run on product pages
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return;

    // Find the first video slide in the product gallery
    var videoSlide = productSection.querySelector('.product__slide[data-type="video"]');
    if (!videoSlide) return;

    var deferredMedia = videoSlide.querySelector('deferred-media');
    if (!deferredMedia) return;

    // Wait for the deferred-media custom element to be fully registered
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('deferred-media').then(function() {
        triggerAutoplay(deferredMedia);
      });
    } else {
      setTimeout(function() {
        triggerAutoplay(deferredMedia);
      }, 1000);
    }
  }

  function triggerAutoplay(deferredMedia) {
    // Manually load deferred media content WITHOUT using loadContent()
    // because loadContent() calls pauseAllMedia() which stops
    // other videos on the page (e.g. the testimonial video ribbon)
    if (!deferredMedia.getAttribute('loaded')) {
      var template = deferredMedia.querySelector('template');
      if (!template) return;
      var clone = template.content.firstElementChild.cloneNode(true);
      deferredMedia.setAttribute('loaded', 'true');
      deferredMedia.appendChild(clone);
    }

    // Wait a frame for the DOM to update, then configure and play
    requestAnimationFrame(function() {
      var video = deferredMedia.querySelector('video');
      if (!video) return;

      // Required attributes for autoplay (browsers require muted)
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false; // Hide video player controls
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.removeAttribute('controls'); // Remove controls UI (pause, skip, progress bar)

      // Play the video
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function(err) {
          console.warn('[GudLife] Video autoplay prevented:', err.message);
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoplayProductVideo);
  } else {
    initAutoplayProductVideo();
  }

  // Re-initialize in Shopify theme editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-section-type="product"]')) {
      setTimeout(initAutoplayProductVideo, 500);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
